import React, { useEffect, useCallback, useState, useMemo } from "react";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import AddressList from "./AddressList";
// import AppealsList from "./AppealsList";
import ContractsList from "./ContractsList";
// import TasksList from "./TasksList";
import PersonsList from "./PersonsList";

import ListWithFilters from "./ListWithFilters/index";

import AccountsList from "../AccountsList";
import BillingHouseList from "../BillingLists/BillingHouseList";
import BillingCardsList from "../BillingLists/BillingCardsList";
import BillingFinstatusList from "../BillingLists/BillingFinstatusList";
import BillingPaymentsList from "../BillingLists/BillingPaymentsList";
import BillingRecalculationsList from "../BillingLists/BillingRecalculationsList";

import EventsList from "../EventsList/EventsList";
// import HistoryTab from "../../HistoryTab/";
import HistoryTab from "../../../pages/Ordering/common/HistoryTab";

import ProxyList from "./ProxyList/index";

import { extractCustomerFromState } from "../../../helpers";

import { withTranslation } from "react-i18next";

import permissions, { checkPermissions } from "config/permissions";
import { openExportWizardModal } from "reducers/exportWizard";

import {
    openCreateNewCustomerModal,
    openAddressModal,
    openCustomerSpecModal,
    openCreateNewOrderModal,
} from "actions/ui";
import { updateCustomerTabContent } from "actions/customer";
import { createNewAppeal } from "modules/appeal/actions";

import BaseService from "../../../services/BaseService";

import DynamicForm from "../../../pages/Ordering/common/DynamicForm";

import Loader from "../../Loader";


import { GET_MAX_FILE_SIZE_FROM_DICT } from 'constants/index';


import "pages/Ordering/styles/styles.scss";

const mapDispatchToProps = {
    openCreateNewCustomerModal,
    openAddressModal,
    openCustomerSpecModal,
    openCreateNewOrderModal,
    updateCustomerTabContent,
    createNewAppeal,
    openExportWizardModal,
};

const STATIC_BLOCK_ADDRESS_FORM_KEY = "cust_address_widget_modal_form";

// static grid with type: proprietary
const PROPRIETARY_CONFIG = {
    // appeals: AppealsList,
    appeals: ListWithFilters,
    // tasks: TasksList,
    tasks: ListWithFilters,

    services: ListWithFilters,
    resources: ListWithFilters,

    documents: ListWithFilters,

    contracts: ContractsList,
    address: AddressList,
    persons: PersonsList,

    accounts: AccountsList,

    billinghouse: BillingHouseList,
    billingcards: BillingCardsList, // should it be replaced with AccountsList?
    billingfinstatus: BillingFinstatusList,
    billingpayments: BillingPaymentsList,
    billingrecalculations: BillingRecalculationsList,

    history: HistoryTab,
    events: EventsList,
};

const TABS_WITH_CUSTOMER_IF_FOR_FILTERS = ["appeals", "tasks", "services", "resources", "documents"];

const GRID_TYPE_CONFIG = {
    appeals: "appeal",
    // tasks: TasksList,
    tasks: "task",

    services: "spec",
    resources: "spec",
    documents: "spec",
};

const CUSTOM_KEY_CONFIG = {
    appeals: "appeal",
    // tasks: TasksList,
    tasks: "task",

    services: "service",
    resources: "resource",
    documents: "document",
};

const CUSTOM_TYPE_CONFIG = {
    appeals: "INTERACTION_REQUEST",
    tasks: "ORDER_TASK",
    documents: "DOCUMENT"
};

const HISTORY_MAP = {
    // appeals: "appeals",
    tasks: "order",
    documents: "document"
};

const CUSTOM_CODE_CONFIG = {
    tasks: "TASK",
};

// dynamic grids with type proxyGrid => Dynamic Grid + Filters on the right side
// {
//     "code": "test",
//     "name": "ТЕСТ",
//     "order": 130,
//     "type": "proxyGrid",
//     "params": {
//         "applyCode": "TEST_FI",
//         "source": "test"
//     }
// }

const CODE_MAP = {
    services: "service",
    resources: "resource",
};

function mapStateToProps(state, props) {
    const customer = extractCustomerFromState(state, props.match.params.id || props.id);

    return {
        addressModificationCount: state.ui.addressModificationCount,
        tabContentModificationCount: customer.tabContentModificationCount,
        isExportAllowed: checkPermissions(permissions.SearchOperations.search_export),
    };
}

function TabContent(props) {
    const {
        t,
        customerId,
        customerType,
        customerTypeId,
        history,
        match,
        config,
        itemId,
        itemType,
        id,
        pApartId,
        customerGridRefresh,
        setCustomerGridRefresh,
        addressModificationCount,
        // openAddressModal,
        // edited,
        tabContentModificationCount,
        openAddressModal,
        openCustomerSpecModal,
        openCreateNewOrderModal,
        updateCustomerTabContent,
        createNewAppeal,
        openExportWizardModal,
        isExportAllowed,
        openCreateNewCustomerModal,
        historyHeightToExtract,
    } = props;
    const GRID_EXPORT_MAP = {
        appeals: () => openExportWizardModal({ luceneCode: CUSTOM_TYPE_CONFIG.appeals }),
        // tasks: () => openExportWizardModal({ luceneCode: CUSTOM_TYPE_CONFIG.tasks }),
        // services: () => openExportWizardModal({ luceneCode: "INTERACTION_REQUEST" }),
        // resources: () => openExportWizardModal({ luceneCode: "INTERACTION_REQUEST" }),
    };


    const [gridRefresh, setGridRefresh] = useState(false);

    const [configCode, tabNum] = config.code.split("_");

    // dynparams logic start
    const [isDynParamsLoading, setIsDynParamsLoading] = useState(false);
    const [dynParams, setDynParams] = useState(null);
    const maxFileSize = useMemo(() => GET_MAX_FILE_SIZE_FROM_DICT('form'), []);
    function fetchDynParams() {
        setDynParams(null);
        setIsDynParamsLoading(true);

        const objectType = config.params ? config.params.objectType : "CUSTOMER";
        const ctxObjectType = config.params ? config.params.ctxObjectType : "CUSTOMER"

        BaseService.get('dinamic_params', {
            data: {
                objectType: `${objectType}@inst`,
                objectTypeId: customerId,
                objectTypeCode: `TAB@${config.code}`,
                ctxObjectType,
                ctxObjectId: customerId,
                openMode: 'update',
                curStepNum: 1,
                overrideIsReq: '',
            },
        })
            .then(({ result, success }) => {
                setIsDynParamsLoading(false);
                if (success) {
                    setDynParams(result.blocks);
                } else {
                    console.log('CustomerPage/TabContent::fetchDynParams: Error during fetching dynamic params');
                }
            })
            .catch((e) => {
                console.log('CustomerPage/TabContent::fetchDynParams: Error during fetching dynamic params');
                setIsDynParamsLoading(false);
            });
    }
    // dynparams logic end

    let fixedFilterObject;
    let initSort;
    let gridConfigCode;

    if (tabNum && config.params) {
        fixedFilterObject =
            typeof config.params.filterObject === "string"
                ? JSON.parse(config.params.filterObject)
                : config.params.filterObject;
        initSort = typeof config.params.sort === "string" ? JSON.parse(config.params.sort) : config.params.sort;
        gridConfigCode = config.params.gridConfig;
    }

    const ActiveList = PROPRIETARY_CONFIG[configCode];

    // move that logic to responsible grid
    function onSelectItem(item) {
        switch (configCode) {
            case "persons": {
                // why did we used item.currentLink.entityId for customerId in the past?
                // history.push(`/customer/${item.currentLink.entityId}/person/${item.id}/contact`);
                history.push(`/customer/${customerId}/person/${item.id}/contact`);
                break;
            }
            case "appeals": {
                history.push(`/appeals/${item.id}`);
                break;
            }
            case "address":
                // openAddressModal({ address: item });
                openAddressModal({
                    customerId,
                    customerObjectType: "CUSTOMER",
                    staticBlockFormKey: STATIC_BLOCK_ADDRESS_FORM_KEY,
                    address: item,
                    onAddressSave: () => setGridRefresh(true),
                });
                break;

            default:
                null;
        }
    }

    const handleCustomerGridRefresh = useCallback(
        value => {
            if (config) {
                setCustomerGridRefresh(configCode, value);
            }
        },
        [config]
    );

    const onCreateNewAppeal = async () => {
        const appealRequestData = {
            customerId,
        };

        try {
            const createdAppeal = await createNewAppeal({ appealRequestData });
            if (createdAppeal) {
                history.push(`/appeals/${createdAppeal.id}/`);
            }
        } catch (e) {
            console.error("TabContent::onCreateNewAppel: Error ", e);
        }
    };

    const gridFloatingButtonHandlers = {
        // appeals: () => onCustomerCrumbNewAppealClick({isContactPerson: false, customer, history, setIsNewAppealCreating }),
        appeals: { asyncHandler: onCreateNewAppeal },
        tasks: () => openCreateNewOrderModal({ openNewTab: true, customer: customerId }),
        services: () => openCustomerSpecModal(customerId, "service"),
        resources: () => openCustomerSpecModal(customerId, "resource"),
        documents: () => openCustomerSpecModal(customerId, "document"),
        address: () =>
            openAddressModal({
                customerId,
                customerObjectType: "CUSTOMER",
                staticBlockFormKey: STATIC_BLOCK_ADDRESS_FORM_KEY,
                onAddressSave: () => setGridRefresh(true),
            }),
        // old modal
        // persons: () =>
        //     openCreateNewContactPersonModal({
        //         customerId: customerId,
        //         customerTypeName: customerType,
        //         customerTypeId: customerTypeId,
        //         onSuccess: () => updateCustomerTabContent(customerId),
        //     }),

        // new modal
        persons: () =>
            openCreateNewCustomerModal({
                customerId: customerId,
                customerPartyType: customerType,
                openNewTab: false,
                withoutTypeSelect: true,
                partyId: customerTypeId,
                partyType: "contactPerson",
                formCode: "customer_grid_new_contactperson_modal",
                isOnlyContactPerson: true,
                title: "newEntityButton.persons",
                callback: () => updateCustomerTabContent(customerId),
            }),

        accounts: () => {
            console.log("*** HANDLE ACCOUNT CREATE ***");
        }
    };

    const showFloatingButton = !config.rightUpButtonOperations.some(permission => !checkPermissions(permission));

    const mainClassName = configCode === "history" ? "contentWrapper" : `customer-ordering-grid ${config.type}`;

    useEffect(() => {
        // if (match.params.subTab === "address") {
        if (match.params.subTab === "address" && addressModificationCount) {
            setGridRefresh(true);
        }
    }, [addressModificationCount]);

    useEffect(() => {
        // setGridRefresh(true);
        if (tabContentModificationCount) {
            setGridRefresh(true);
        }
    }, [tabContentModificationCount]);
    

    useEffect(() => {
        if (config && config.type === 'dynForm' && !dynParams && !isDynParamsLoading) {
            fetchDynParams();
        }
        return () => {
            setDynParams(null);
        }
    }, [config]);

    if (config && config.type === "proprietary" && !ActiveList) {
        console.error(
            `Proprietary list is not found, probably wrong configured customer tab ${configCode}. Usage of "_" allowed only for indixing the tab, for example billingcards_1, billing_cards_1 is not correct`
        );
        return (
            <div className="customer-list-not-found-error">
                Proprietary List for <strong>{configCode}</strong> ({config.code}) is not found. Make sure to use{" "}
                <strong>_</strong> only for indexing existing tabs.
            </div>
        );
    }
    return (
        <div className={mainClassName}>
            {config.type === "proprietary" && (
                <ActiveList
                    selectItem={onSelectItem}
                    gridRefresh={customerGridRefresh[configCode] || gridRefresh}
                    setGridRefresh={customerGridRefresh[configCode] ? handleCustomerGridRefresh : setGridRefresh}
                    itemId={itemId}
                    itemType={itemType}
                    pApartId={pApartId}
                    id={id}
                    code={CODE_MAP[configCode] || configCode}
                    objectType="CUSTOMER"
                    fixedFilterObject={fixedFilterObject}
                    tabNum={tabNum}
                    initSort={initSort}
                    gridConfigCode={gridConfigCode}
                    gridCustomType={CUSTOM_TYPE_CONFIG[configCode]}
                    gridCustomCode={CUSTOM_CODE_CONFIG[configCode]}
                    gridType={GRID_TYPE_CONFIG[configCode]}
                    gridConfigKey={CUSTOM_KEY_CONFIG[configCode]}
                    onGridExport={isExportAllowed && GRID_EXPORT_MAP[configCode]}
                    customerId={customerId}
                    historyPath={HISTORY_MAP[configCode]}
                    shouldIncludeCustomersId={TABS_WITH_CUSTOMER_IF_FOR_FILTERS.includes(configCode)}
                    historyHeightToExtract={historyHeightToExtract}
                    key={itemId ? `${id}_${itemId}_${itemType}` : id}
                    onGridFloatingButtonClick={showFloatingButton && gridFloatingButtonHandlers[configCode]}
                />
            )}
            {config.type === "proxyGrid" && (
                <ProxyList config={config} id={id} itemId={itemId} itemType={itemType} key={id} />
            )}
            {config.type === "dynForm" && (
                <>
                    {isDynParamsLoading && <Loader />}
                    {dynParams && (
                        <DynamicForm
                            formName={`customer-tab-dynamic-form-${config.code}`}
                            // readonly={!actions.updParams}
                            dynData={dynParams}
                            currentId={customerId}
                            refreshDynParams={fetchDynParams}
                            maxFileSize={maxFileSize}
                            uploadFileSource="form"
                            liveSave
                            isLiveSaveOnlyValid
                            t={t}
                            confGridObjectType={`TAB@${config.code}`}
                            objectType={`TAB@${config.code}`}
                            objectTypeSpec={customerId}
                            confGridCacheType={config.params && config.params.objectType}
                        />
                    )}
                </>
            )}
        </div>
    );
}

// export default withTranslation()(withRouter(connect(mapStateToProps, null)(TabContent)));
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(TabContent)));
